export default "__VITE_ASSET__bh7cy2gB__"